import { render } from "./FileBatchesSettings.vue?vue&type=template&id=f93a3a22"
import script from "./FileBatchesSettings.vue?vue&type=script&lang=js"
export * from "./FileBatchesSettings.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ramazansapar/qbox-transcriber-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__